import { AccessoryModel } from './accessory.model';
import { ModelIncludeModel } from './model-include.model';
import { ResourceModel } from './resource.model';
import { ImageModel } from './image.model';
import { AttributeModel } from './attribute.model';
import { ProductModel } from './product.model';
import { ImageUploadImageSetModel } from '../../image-admin/image-models/image-upload-image-set.model';
import { AHRIInformation } from './aHRIInformation';
export class ModelModel {
  id: string;
  modelNumber: string;
  attributes: AttributeModel[];
  ahriInformation: AHRIInformation[];
  images: ImageUploadImageSetModel[];
  displayImage1: Boolean;
  displayImage2: Boolean;
  displayImage3: Boolean;
  publishon: string;
  unpublishon: string;
  resources: ResourceModel[];
  includes: ModelIncludeModel[];
  relatedAccessories: ProductModel[];
  productClass: string[];
  line: string[];
  productCategory: string;
  productFamily: string;
  modelType: string;
  lgModelNo: string;
  constructor(data?) {
    const modelData = data || {};
    this.id = modelData.id;
    this.modelNumber = modelData.modelNumber;
    this.displayImage1 = modelData.displayImage1;
    this.displayImage2 = modelData.displayImage2;
    this.displayImage3 = modelData.displayImage3;
    this.publishon = modelData.publishOn;
    this.unpublishon = modelData.unpublishOn;
    this.attributes = modelData.attributes ? modelData.attributes.map(item => new AttributeModel(item)) : [];
    this.ahriInformation = modelData.ahriInformation ? modelData.ahriInformation.map(item => new AHRIInformation(item)) : [];;
    this.images = modelData.imageSets ? modelData.imageSets.map(item => new ImageUploadImageSetModel(item)) : [];
    this.resources = modelData.resources ? modelData.resources.map(item => new ResourceModel(item)) : [];
    this.includes = modelData.includes ? modelData.includes.map(item => new ModelIncludeModel(item)) : [];
    this.relatedAccessories = modelData.relatedAccessories ? modelData.relatedAccessories.map(item => new ProductModel(item)) : [];
    this.productClass = modelData.productClass ? modelData.productClass.map(item => item) : [];
    this.line = modelData.line ? modelData.line.map(item => item) : [];
    this.productCategory = modelData.productCategory;
    this.productFamily = modelData.productFamily;
    this.modelType = modelData.modelType;
    this.lgModelNo = modelData.lgModelNo;
  }

  shouldDisplayModel(iscommercial: string, productClass: string): boolean {
    let isInLine = false;
    if (iscommercial === 'true') {
      for (const line of this.line ) {
        if (line === 'Commercial') {
          isInLine = true;
          break;
        }
      }
      if (! isInLine) {
        return false;
      }
      if (! productClass) {
        // If class not selected show all models
        return true;
      }
      switch (productClass) {
        case 'Outdoor Units':
          for (const item of this.productClass) {
            if (item === 'Multi V' && this.productCategory === 'Outdoor Units') {
              return true;
            }
          }
          return false;

        case 'Indoor Units':
          for (const item of this.productClass) {
            if (item === 'Multi V' && this.productCategory === 'Indoor Units') {
              return true;
            }
          }
          return false;

        case 'Controls':
        case 'Accessories':
        case 'Air Technologies':
        case 'Chillers':
          for (const item of this.productClass) {
            if (item === 'Multi V' && this.productCategory === productClass) {
              return true;
            }
          }
          return false;

        default:
          return false;
      }
    } else {
      for (const line of this.line ) {
        if (line === 'Residential/Light Commercial') {
          isInLine = true;
          break;
        }
      }
      if (! isInLine) {
        return false;
      }

      if (! productClass) {
        // If class not selected show all models
        return true;
      }

      switch (productClass) {
        case 'Single Zone':
          for (const item of this.productClass) {
            if (item === 'Single Zone' && this.productCategory === 'Indoor Units') {
              return true;
            }
          }
          return false;

        case 'Multi Zone Indoor':
          for (const item of this.productClass) {
            if (item === 'Multi Zone' && this.productCategory === 'Indoor Units') {
              return true;
            }
          }
          return false;

        case 'Multi Zone Outdoor':
          for (const item of this.productClass) {
            if (item === 'Multi Zone' && this.productCategory === 'Outdoor Units') {
              return true;
            }
          }
          return false;

        case 'Controls':
        case 'Accessories':
        case 'Water Heating':
        case 'Air Technologies':
          for (const item of this.productClass) {
            if ( (item === 'Multi Zone' || item === 'Single Zone') && this.productCategory === productClass) {
              return true;
            }
          }
          return false;

        case 'PTAC':
          for (const item of this.productClass) {
            if ( (item === 'PTAC') || this.productFamily === 'PTAC Units') {
              return true;
            }
          }
          return false;

        default :
          return false;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/product-category/models/model.model.ts